module.exports = __webpack_public_path__ + "static/media/attr_ambulance.b42527aa.svg";